import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BorderClearIcon(props: IconProps) {
    return <Icon {...props} iconKey={"border_clear"}/>
}
